import { render, staticRenderFns } from "./GreetingMessage.vue?vue&type=template&id=7dd1fa94"
import script from "./GreetingMessage.vue?vue&type=script&lang=js"
export * from "./GreetingMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports